import React, { useState, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import Searchbar from '../../components/Searchbar/Searchbar';
import ChevronRight from '../../assets/icons/common/chevron-right.svg';
import ChevronDown from '../../assets/icons/common/chevron-down-bigger.svg';
import './ReceiversModal.css';

function ReceiversModal({ cmses, cmsList, onClose }) {
  const [expandedRows, setExpandedRows] = useState({});
  const [searchValue, setSearchValue] = useState('');

  const handleExpandClick = (cmsId) => {
    console.log(cmsId);
    setExpandedRows((prev) => ({
      ...prev,
      [cmsId]: !prev[cmsId],
    }));
  };

  const subTableData = useMemo(() => {
    return cmses.map((cms) => {
      let cmsName = '';
      cmsList.forEach((cmsObj) => {
        if (cms.cms_id === cmsObj.id) {
          cmsName = cmsObj.name;
        }
      });
      return {
        cmsName,
        cmsId: cms.cms_id,
        receivers: cms.receivers,
      };
    });
  }, [cmses, cmsList]);

  // Filter the CMSes and receivers based on the search value
  const filteredCmses = subTableData.map(cms => {
    const filteredReceivers = cms.receivers.filter(receiver =>
      receiver.toLowerCase().includes(searchValue.toLowerCase())
    );
    return {
      ...cms,
      receivers: filteredReceivers
    };
  }).filter(cms => cms.cmsName.toLowerCase().includes(searchValue.toLowerCase()) ||
    cms.cmsId.toString().includes(searchValue) ||
    cms.receivers.length > 0 // Only include CMSes with matching receivers
  );

  return (
    <div className="modal fade" id="receiversModal" tabIndex="-1" aria-labelledby="receiversModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="receiversModalLabel"><FormattedMessage id="RECEIVERS" /></h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <Searchbar search={setSearchValue} />
            <div className="card mt-3">
              <table className="table receiversModal">
                <thead>
                  <tr>
                    <th></th>
                    <th><FormattedMessage id="CMS" /></th>
                    <th><FormattedMessage id="ID" /></th>
                    <th><FormattedMessage id="TOTAL_RECEIVERS" /></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCmses.map((cms, index) => (
                    <React.Fragment key={index}>
                      <tr
                        className={expandedRows[cms.cmsId] ? 'expanded-row' : ''}
                      >
                        <td>
                          <button 
                            type="button" 
                            className="btn btn-link p-0" 
                            onClick={() => handleExpandClick(cms.cmsId)}
                          >
                            {expandedRows[cms.cmsId] ? <img src={ChevronDown} alt="Reduce" /> : <img src={ChevronRight} alt="Expand" />}
                          </button>
                        </td>
                        <td>{cms.cmsName}</td>
                        <td>{cms.cmsId}</td>
                        <td>{cms.receivers.length}</td>
                      </tr>
                      {expandedRows[cms.cmsId] && (
                        <tr>
                           <td colSpan="4">
                            <div>
                              <strong><FormattedMessage id="RECEIVERS" /></strong>
                              <ul style={{ listStyleType: 'none', paddingLeft: 0, marginTop: '10px' }}>
                                {cms.receivers.map((receiver, i) => (
                                  <li key={i}>{receiver}</li>
                                ))}
                              </ul>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer justify-content-start">
            <button type="button" className="btn back-btn" data-bs-dismiss="modal" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReceiversModal;
